import * as Dialog from '@radix-ui/react-dialog';
import {
  type ForwardedRef,
  forwardRef,
  type HTMLAttributes,
  type ReactNode,
} from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';

interface SlideOutCloseProps
  extends Omit<
    Dialog.DialogCloseProps & ComponentProps<HTMLAttributes<HTMLButtonElement>>,
    'className'
  > {
  children: ReactNode;
}

export const SlideOutClose = forwardRef<HTMLButtonElement, SlideOutCloseProps>(
  (
    { children, ...props }: SlideOutCloseProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const className = getClassNameOverride(props, 'SlideOut.Close');

    return (
      <Dialog.Close ref={ref} {...props} className={className} asChild>
        {children}
      </Dialog.Close>
    );
  },
);

SlideOutClose.displayName = 'SlideOut.Close';
